var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBird3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 253,
    viewBox: "0 0 202 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.932 247.78C188.986 247.78 202 245.486 202 242.656C202 239.826 188.986 237.532 172.932 237.532C156.879 237.532 143.865 239.826 143.865 242.656C143.865 245.486 156.879 247.78 172.932 247.78Z",
    fill: "url(#paint0_radial_2_949)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.854 64.2825C148.854 64.2825 146.799 46.9101 159.654 41.8079C172.508 36.7056 148.854 64.2825 148.854 64.2825Z",
    fill: "#070707"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.83 62.7565C148.83 62.7565 174.96 54.0377 181.454 60.9855C187.947 67.9301 156.045 67.7316 148.83 62.7565Z",
    fill: "#070707"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4076 235.876C85.6645 236.118 93.8391 243.937 96.826 248.047C99.8594 252.228 91.3165 250.367 83.2131 236.223C83.2131 236.223 76.6295 243.028 74.3111 242.833C72.002 242.637 80.7214 237.523 80.935 234.523C81.0402 233.022 80.4862 227.886 80.1643 221.617C79.9352 217.077 79.8299 211.946 80.1797 207.182C80.3128 205.377 80.5109 203.628 80.7957 201.984C80.7957 201.984 81.5231 200.365 82.0276 202.018C82.0276 202.018 81.9657 203.829 81.9038 206.599C81.8202 210.575 81.7521 216.528 81.8883 221.928C82.04 227.557 82.4207 232.591 83.2657 234.173C83.2657 234.173 96.2967 236.691 98.9772 238.673C101.621 240.624 85.8193 235.994 85.4076 235.876Z",
    fill: "url(#paint1_linear_2_949)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9038 206.599C81.8203 210.575 81.7521 216.528 81.8883 221.928C81.2631 221.822 80.6843 221.72 80.1643 221.62C79.9352 217.08 79.83 211.949 80.1797 207.185C80.7338 206.974 81.3095 206.785 81.9038 206.599Z",
    fill: "url(#paint2_linear_2_949)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.288 228.959C105.288 228.959 115.716 233.32 117.357 235.262C118.997 237.197 105.239 228.804 98.2406 228.472C91.2422 228.14 88.215 228.37 90.3353 227.452C92.4555 226.534 98.1725 227.036 98.1725 227.036C98.1725 227.036 98.1725 225.535 98.188 223.224C98.222 218.767 98.2994 211.298 98.5222 205.765C98.5656 204.502 98.6275 203.342 98.6894 202.341C99.1939 194.667 99.9306 200.064 99.8656 202.368C99.8656 202.368 99.8222 203.86 99.7603 206.118C99.6365 210.672 99.4539 218.345 99.4415 223.177C99.4353 225.349 99.4694 226.94 99.5591 227.427C99.5591 227.427 115.868 227.225 118.521 227.495C121.18 227.771 111.086 228.23 111.086 228.23C111.086 228.23 120.793 228.736 123.337 231.208C125.891 233.677 112.083 229.282 105.288 228.959Z",
    fill: "url(#paint3_linear_2_949)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7634 206.118C99.6396 210.672 99.457 218.345 99.4446 223.178C99.0236 223.199 98.6058 223.218 98.191 223.221C98.2251 218.764 98.3025 211.295 98.5253 205.762C98.9339 205.876 99.3487 205.994 99.7634 206.118Z",
    fill: "url(#paint4_linear_2_949)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.174 142.435C147.174 142.435 159.406 163.514 144.051 183.749C128.695 203.984 128.958 140.301 147.174 142.435Z",
    fill: "#282827"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.998 214.884C107.452 219.915 97.5565 222.604 87.6455 222.498C76.2178 222.377 66.0623 216.599 56.4112 210.994C37.9108 200.247 19.9954 187.549 10.2082 167.946C6.34842 160.211 3.79484 151.948 3.25317 144.125C2.92507 139.457 3.10456 134.656 4.30553 130.14C4.63053 128.896 5.01745 126.021 6.4846 125.481C6.74151 125.385 7.25534 125.472 7.81868 125.661C8.70393 125.956 9.70676 126.489 9.98843 126.93C10.0782 127.076 10.0875 127.215 9.98843 127.327C11.1894 125.996 11.7249 123.993 12.9971 122.584C13.093 122.581 13.1889 122.6 13.2849 122.637C14.622 123.056 16.1326 126.148 16.2099 127.408C16.2099 127.445 16.213 127.485 16.213 127.528C16.2316 126.297 17.9711 125.717 19.0328 126.347C20.0945 126.976 20.5464 128.273 20.7785 129.489C21.574 133.636 21.7133 134.991 25.6814 135.903C29.0893 136.685 32.5932 137.181 36.1001 136.948C44.6585 136.374 52.1831 131.44 58.3674 125.41C60.3948 123.441 76.7966 100.066 78.4557 96.8251C79.4895 97.4486 79.6473 99.5267 79.9847 100.591C80.4954 102.2 80.6378 103.745 80.8081 105.407C81.845 115.305 85.8131 124.836 89.7596 134.2C95.5323 147.869 102.057 162.379 114.782 170.849C117.354 172.555 120.186 173.988 123.216 174.494C127.89 175.269 132.474 173.743 136.705 172.013C140.277 170.555 142.741 168.914 145.326 166.181C146.963 164.457 150.532 156.303 153.212 156.669C153.776 156.743 145.843 174.599 145.202 175.865C137.612 190.908 131.109 205.979 115.998 214.884Z",
    fill: "#D6D6D6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5084 138.071C10.5084 138.071 9.52721 129.253 7.82172 125.667C8.70696 125.962 9.70983 126.496 9.9915 126.936C10.007 127.069 10.0008 127.2 9.9915 127.333C9.9915 127.33 10.6694 132.938 10.5084 138.071Z",
    fill: "url(#paint5_linear_2_949)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.288 122.637C14.6251 123.056 16.1356 126.148 16.213 127.407C16.213 127.445 16.2161 127.485 16.2161 127.528C16.2161 127.528 17.4202 135.605 17.3985 138.288C17.3737 140.968 14.6344 125.615 13.288 122.637Z",
    fill: "url(#paint6_linear_2_949)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.869 187.226C94.6996 177.385 79.4245 121.57 78.0904 97.5478C78.0935 97.5416 78.0873 97.5385 78.0935 97.5323C78.9292 96.1118 79.8299 94.6198 80.808 93.0938C92.4865 74.7847 113.958 50.5577 141.565 57.8063C141.565 57.8063 169.456 65.4549 170.964 97.8518C171.273 104.44 170.493 112.051 168.156 120.826C166.528 126.967 164.139 133.682 160.842 141.018C158.577 146.045 156.181 150.986 153.671 155.819L150.807 161.2L150.693 161.405C150.693 161.405 150.69 161.411 150.681 161.423C150.111 162.348 128.797 196.934 111.869 187.226Z",
    fill: "#282827"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M111.869 187.226C94.6996 177.385 79.4245 121.57 78.0904 97.5478C78.0935 97.5416 78.0873 97.5385 78.0935 97.5323C78.9292 96.1117 79.8299 94.6198 80.808 93.0938C80.8111 93.1031 80.8111 93.1031 80.8111 93.1031C80.8111 93.1031 107.028 218.426 153.674 155.819L150.81 161.2L150.696 161.405C150.696 161.405 150.693 161.411 150.684 161.423C150.111 162.348 128.797 196.934 111.869 187.226Z",
    fill: "#373737"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.738 61.2863C116.738 61.2863 135.47 52.2574 151.609 63.9041C167.745 75.5539 100.847 70.1384 116.738 61.2863Z",
    fill: "url(#paint7_linear_2_949)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M129.354 200.399C129.354 200.399 107.195 229.62 72.7325 217.796C38.273 205.969 146.165 184.044 129.354 200.399Z",
    fill: "url(#paint8_linear_2_949)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M134.632 120.643C134.632 120.643 127.921 130.956 132.988 135.394C138.058 139.833 143.475 123.009 143.475 123.009L134.632 120.643Z",
    fill: "url(#paint9_linear_2_949)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M139.302 99.8555C134.325 109.272 123.557 113.348 115.252 108.962C106.948 104.576 104.252 93.3854 109.229 83.9719C114.206 74.5552 124.974 70.4797 133.279 74.8654C141.584 79.2512 144.28 90.4388 139.302 99.8555Z",
    fill: "url(#paint10_linear_2_949)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M137.683 100.467C133.041 109.247 122.996 113.053 115.252 108.962C107.508 104.871 104.991 94.4338 109.634 85.653C114.277 76.8722 124.321 73.0665 132.066 77.1576C139.81 81.2486 142.326 91.6857 137.683 100.467Z",
    fill: "url(#paint11_radial_2_949)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M131.977 104.593C134.53 99.8482 133.212 94.1708 129.032 91.9123C124.852 89.6538 119.393 91.6695 116.84 96.4145C114.287 101.16 115.606 106.837 119.786 109.095C123.966 111.354 129.424 109.338 131.977 104.593Z",
    fill: "#070707"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M124.89 98.0464C126.246 97.0658 125.044 93.0778 122.207 89.1389C119.369 85.2 115.97 82.8017 114.615 83.7823C113.259 84.7628 114.461 88.7509 117.298 92.6898C120.136 96.6287 123.535 99.0269 124.89 98.0464Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M118.221 100.575C117.991 102.328 116.713 103.708 115.367 103.652C114.02 103.599 113.113 102.135 113.342 100.38C113.571 98.6272 114.85 97.247 116.196 97.3028C117.543 97.3586 118.45 98.8226 118.221 100.575Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M168.153 120.826C164.123 125.239 158.809 127.122 154.689 125.087C149.176 122.377 147.861 113.711 151.748 105.746C155.63 97.7773 163.247 93.5219 168.757 96.2327C169.589 96.6422 170.323 97.188 170.961 97.8487C171.27 104.44 170.49 112.051 168.153 120.826Z",
    fill: "url(#paint12_linear_2_949)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M170.552 116.22C166.928 123.651 159.827 127.622 154.686 125.091C149.548 122.56 148.319 114.483 151.943 107.051C155.568 99.6197 162.672 95.6496 167.81 98.1806C172.948 100.712 174.177 108.788 170.552 116.22Z",
    fill: "url(#paint13_radial_2_949)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M164.469 122.124C167.309 119.138 167.935 115.116 165.867 113.142C163.799 111.167 159.821 111.986 156.981 114.973C154.141 117.959 153.515 121.98 155.583 123.955C157.651 125.93 161.629 125.11 164.469 122.124Z",
    fill: "#070707"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M161.55 117.023C162.726 116.775 163.159 114.104 162.517 111.058C161.876 108.013 160.403 105.745 159.227 105.994C158.051 106.243 157.618 108.913 158.259 111.959C158.9 115.004 160.374 117.272 161.55 117.023Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M156.818 117.932C156.209 119.107 155.042 119.908 154.206 119.722C153.37 119.536 153.188 118.434 153.797 117.259C154.407 116.083 155.574 115.283 156.41 115.469C157.246 115.655 157.428 116.756 156.818 117.932Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M180.154 99.719L175.443 87.6598C175.263 87.2038 174.718 86.9743 174.276 87.1666L171.047 88.5778C170.595 88.7763 170.456 89.3222 170.75 89.7348L178.429 100.532C178.689 100.898 179.194 101.019 179.572 100.805L179.832 100.656C180.163 100.467 180.296 100.079 180.154 99.719Z",
    fill: "#070707"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M129.172 63.9103L142.323 63.8266C142.822 63.8235 143.24 64.236 143.215 64.7137L143.054 68.1813C143.032 68.6652 142.565 68.9939 142.063 68.8761L129.026 65.7868C128.583 65.6814 128.286 65.2658 128.351 64.8408L128.398 64.5462C128.46 64.1771 128.778 63.9103 129.172 63.9103Z",
    fill: "#070707"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3407 175.654C26.5016 175.586 26.644 175.53 26.7616 175.486C26.6224 175.545 26.4831 175.601 26.3407 175.654Z",
    fill: "url(#paint14_linear_2_949)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M135.176 118.822C135.176 118.822 139.166 108.438 145.372 106.847C151.575 105.259 149.062 116.896 147.359 120.001C145.657 123.102 135.176 118.822 135.176 118.822Z",
    fill: "#070707"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M134.833 119.982C133.264 124.191 134 128.102 136.476 128.713C138.953 129.324 142.234 126.409 143.803 122.2C145.372 117.991 144.635 114.08 142.159 113.469C139.683 112.858 136.402 115.773 134.833 119.982Z",
    fill: "url(#paint15_linear_2_949)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M135.597 119.39C136.269 119.96 137.436 119.995 138.327 120.143C139.25 120.295 140.163 120.506 141.042 120.776C144.982 121.989 146.555 124.994 149.514 127.392C150.027 127.811 150.102 127.836 150.229 127.451C150.603 126.322 150.749 125.134 150.712 123.943C150.606 120.584 149.867 114.213 145.973 110.9C145.778 110.882 145.577 110.885 145.382 110.888C143.478 110.928 141.605 111.527 140.095 112.458C138.816 113.242 137.783 114.266 136.978 115.386C136.452 116.114 136.021 116.89 135.662 117.684C135.433 118.192 135.012 118.763 135.455 119.253C135.501 119.303 135.548 119.346 135.597 119.39Z",
    fill: "url(#paint16_linear_2_949)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M147.121 115.023C147.115 114.684 146.666 112.833 144.137 111.927C141.605 111.025 147.17 117.324 147.121 115.023Z",
    fill: "url(#paint17_linear_2_949)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M141.76 125.897C141.76 125.897 142.602 127.839 142.23 129.194C142.23 129.194 137.16 128.974 137.16 128.884C137.16 128.794 138.782 128.617 139.912 127.733C141.172 126.744 141.76 125.897 141.76 125.897Z",
    fill: "url(#paint18_linear_2_949)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M134.09 124.994C134.09 124.994 137.64 128.394 142.23 129.194C142.23 129.191 134.715 132.125 134.09 124.994Z",
    fill: "url(#paint19_linear_2_949)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M193.689 225.895C193.77 227.408 192.993 228.711 191.953 228.807C190.913 228.903 190 227.752 189.919 226.239C189.839 224.725 190.616 223.423 191.656 223.326C192.696 223.23 193.609 224.381 193.689 225.895Z",
    fill: "url(#paint20_linear_2_949)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M193.572 226.09C193.649 227.501 192.922 228.717 191.953 228.807C190.984 228.897 190.133 227.824 190.055 226.413C189.978 225.001 190.705 223.785 191.674 223.695C192.646 223.606 193.497 224.679 193.572 226.09Z",
    fill: "url(#paint21_radial_2_949)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M192.429 226.195C192.457 226.689 192.203 227.113 191.863 227.144C191.526 227.175 191.228 226.8 191.201 226.31C191.173 225.817 191.427 225.392 191.767 225.361C192.104 225.327 192.402 225.702 192.429 226.195Z",
    fill: "#2D3466"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M191.755 226.028C191.721 226.177 191.433 226.161 191.108 226C190.783 225.839 190.551 225.584 190.585 225.435C190.619 225.287 190.907 225.302 191.232 225.463C191.553 225.628 191.789 225.879 191.755 226.028Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M191.439 226.555C191.492 226.704 191.467 226.872 191.383 226.934C191.3 226.996 191.188 226.924 191.136 226.779C191.083 226.633 191.108 226.462 191.191 226.4C191.275 226.338 191.386 226.406 191.439 226.555Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M193.454 225.6C193.166 225.479 192.86 225.426 192.544 225.457C191.581 225.547 190.777 226.366 190.365 227.52C190.226 227.191 190.139 226.813 190.114 226.406C190.04 225.042 190.743 223.863 191.68 223.779C192.504 223.702 193.234 224.489 193.454 225.6Z",
    fill: "url(#paint22_linear_2_949)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M184.165 233.829C184.066 232.932 182.441 224.22 184.165 221.217C185.889 218.215 191.882 217.988 192.553 227.523C193.225 237.057 193.302 243.438 185.663 243.962C178.024 244.486 174.653 235.255 171.654 234.88C168.658 234.505 168.283 242.535 163.489 242.761C158.694 242.988 157.27 239.458 155.475 239.235C153.677 239.008 152.928 241.186 151.129 241.037C149.331 240.888 147.907 240.513 151.129 236.909C154.352 233.304 156.447 234.508 158.694 235.708C160.941 236.909 162.214 236.608 164.987 232.331C167.757 228.053 170.53 225.724 174.65 229.102C178.773 232.479 184.865 240.119 184.165 233.829Z",
    fill: "url(#paint23_linear_2_949)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M192.838 235.404C192.132 235.714 191.402 235.941 190.662 236.074C189.919 236.201 189.167 236.251 188.427 236.173C187.688 236.105 186.948 235.947 186.251 235.668C185.539 235.417 184.886 235.023 184.218 234.632C184.506 234.886 184.793 235.15 185.109 235.379C185.44 235.581 185.759 235.814 186.124 235.966C186.824 236.329 187.607 236.512 188.39 236.592C189.963 236.735 191.584 236.31 192.838 235.404Z",
    fill: "#BA7071"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M182.305 235.851C181.633 235.752 180.915 235.873 180.299 236.229C179.671 236.574 179.213 237.197 178.993 237.87C178.863 238.205 178.835 238.559 178.786 238.906C178.779 239.253 178.773 239.604 178.813 239.945C178.875 240.283 178.912 240.624 178.996 240.956C179.101 241.282 179.191 241.611 179.306 241.927C179.241 241.248 179.148 240.59 179.135 239.926C179.148 239.269 179.166 238.608 179.389 238.01C179.581 237.405 179.952 236.874 180.469 236.505C180.989 236.13 181.636 235.925 182.305 235.851Z",
    fill: "#BA7071"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M174.653 229.102C174.022 229.068 173.375 229.248 172.821 229.598C172.258 229.942 171.83 230.494 171.577 231.102C171.31 231.716 171.276 232.38 171.28 233.019C171.32 233.339 171.348 233.655 171.4 233.968C171.487 234.275 171.558 234.582 171.654 234.883C171.623 234.25 171.58 233.633 171.601 233.022C171.673 232.417 171.716 231.806 171.964 231.267C172.388 230.153 173.421 229.365 174.653 229.102Z",
    fill: "#BA7071"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M169.849 235.851C169.227 235.897 168.614 235.91 168.014 235.854C167.417 235.789 166.825 235.674 166.321 235.395C165.81 235.128 165.445 234.666 165.247 234.117C165.021 233.571 165.021 232.951 164.987 232.327C164.925 232.631 164.863 232.942 164.835 233.258C164.854 233.574 164.829 233.9 164.937 234.216C165.077 234.855 165.522 235.451 166.117 235.764C166.708 236.077 167.364 236.186 167.998 236.177C168.636 236.167 169.261 236.068 169.849 235.851Z",
    fill: "#BA7071"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M161.155 236.245C160.375 237.113 160 238.357 160.115 239.554C160.189 240.147 160.328 240.745 160.629 241.26C160.749 241.533 160.941 241.763 161.096 242.011C161.282 242.237 161.483 242.454 161.687 242.656C161.406 242.144 161.115 241.657 160.923 241.127C160.706 240.609 160.595 240.06 160.533 239.514C160.418 238.413 160.66 237.29 161.155 236.245Z",
    fill: "#BA7071"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M153.661 234.88C153.38 235.252 153.203 235.702 153.113 236.17C153.021 236.642 153.058 237.151 153.24 237.616C153.435 238.069 153.748 238.487 154.169 238.732C154.361 238.881 154.593 238.953 154.8 239.061C155.026 239.126 155.252 239.191 155.478 239.235C155.082 238.99 154.686 238.776 154.367 238.475C154.03 238.196 153.791 237.839 153.63 237.458C153.308 236.679 153.42 235.767 153.661 234.88Z",
    fill: "#BA7071"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M174.625 229.306C174.625 229.306 172.703 227.514 170.716 227.694C168.729 227.87 167.754 229.009 167.559 229.57C167.361 230.135 176.492 230.519 174.625 229.306Z",
    fill: "url(#paint24_linear_2_949)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M158.561 236.003C158.561 236.003 156.868 234.412 155.119 234.57C153.37 234.728 152.513 235.736 152.336 236.235C152.16 236.735 160.205 237.076 158.561 236.003Z",
    fill: "url(#paint25_linear_2_949)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M190.359 221.165C190.278 221.087 189.009 219.214 186.712 219.514C184.416 219.815 192.556 223.24 190.359 221.165Z",
    fill: "url(#paint26_linear_2_949)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M165.888 241.471C165.888 241.471 163.154 244.135 159.257 241.471C155.361 238.807 168.509 239.409 165.888 241.471Z",
    fill: "url(#paint27_linear_2_949)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M190.532 241.636C190.532 241.636 184.747 246.183 179.646 241.636C174.542 237.092 192.829 238.934 190.532 241.636Z",
    fill: "url(#paint28_linear_2_949)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M190.715 225.885C190.842 227.703 189.647 229.266 188.047 229.381C186.446 229.496 185.047 228.115 184.923 226.301C184.8 224.486 185.991 222.92 187.592 222.805C189.192 222.691 190.588 224.071 190.715 225.885Z",
    fill: "url(#paint29_linear_2_949)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M190.535 226.121C190.653 227.814 189.538 229.275 188.046 229.381C186.555 229.489 185.248 228.202 185.131 226.509C185.013 224.815 186.127 223.354 187.619 223.249C189.114 223.14 190.417 224.427 190.535 226.121Z",
    fill: "url(#paint30_radial_2_949)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M187.901 224.669C187.941 225.262 187.554 225.77 187.031 225.808C186.511 225.845 186.056 225.395 186.013 224.806C185.969 224.217 186.36 223.705 186.883 223.668C187.406 223.627 187.861 224.077 187.901 224.669Z",
    fill: "#2D3466"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M186.864 224.468C186.802 224.642 186.552 224.707 186.304 224.61C186.056 224.514 185.905 224.297 185.966 224.124C186.028 223.95 186.279 223.885 186.527 223.981C186.774 224.077 186.926 224.294 186.864 224.468Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M186.381 225.101C186.462 225.277 186.422 225.482 186.295 225.553C186.165 225.628 185.998 225.544 185.917 225.367C185.837 225.19 185.877 224.989 186.004 224.914C186.134 224.84 186.301 224.924 186.381 225.101Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36485 151.399C-6.41022 124.017 17.8195 63.6715 37.7715 21.2656C40.5016 15.4623 43.6216 9.42342 47.9457 4.42664C50.7531 1.18231 55.6529 1.93601 56.3462 5.50912C56.4081 5.82859 56.4793 6.12014 56.566 6.37758C56.6062 2.88821 61.1717 -0.663181 64.6353 0.106031C68.0958 0.875243 68.8696 6.75909 66.0963 9.64053C65.923 8.02147 68.9563 7.05064 70.0087 8.20136C71.0611 9.35208 70.6649 11.2782 70.2161 12.9686C58.451 57.3999 42.953 101.639 23.9326 145.112C26.0962 165.884 9.73158 183.954 2.36485 151.399Z",
    fill: "#1A1718"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1985 12.0598C54.6222 50.9423 37.9449 90.3334 22.4531 128.62C21.9362 129.895 19.8283 129.799 20.3452 128.502C27.5015 110.597 33.2834 92.8519 41.3992 75.1445C50.945 54.3106 55.3 32.5463 65.3906 11.9078C65.6104 11.455 66.3346 11.5977 66.1985 12.0598Z",
    fill: "#EBEBEA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5412 6.65673C52.3038 19.8605 47.4721 33.0581 42.3897 46.1471C37.1649 59.599 33.8436 73.3952 28.2412 86.7416C28.0834 87.12 27.5107 86.9804 27.5943 86.6207C30.7948 73.1005 37.0318 59.4966 41.3218 46.0168C45.5128 32.841 50.1526 19.6341 55.2505 6.5823C55.5507 5.80998 56.8012 5.8379 56.5412 6.65673Z",
    fill: "#EBEBEA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9381 30.6233C47.7352 47.0155 42.823 63.4481 37.0906 79.8838C36.9947 80.1568 36.5923 80.1382 36.648 79.859C40.0559 63.4791 46.6116 46.5348 53.6781 30.5767C53.7431 30.4309 53.9938 30.4775 53.9381 30.6233Z",
    fill: "#EBEBEA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M52.802 130.612C52.802 130.612 68.2381 122.526 78.7342 139.644C89.2302 156.762 91.4959 190.511 65.5298 199.934C39.5636 209.357 13.8853 168.557 10.5733 160.53C7.26141 152.503 17.7729 158.154 17.7729 158.154C17.7729 158.154 8.53359 153.223 6.03572 147.475C3.53784 141.728 18.3425 145.459 18.3425 145.459C18.3425 145.459 2.90948 140.112 2.57519 132.504C2.24091 124.895 28.3866 137.271 52.802 130.612Z",
    fill: "url(#paint31_linear_2_949)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8548 195.83C51.4433 201.06 37.1246 190.07 27.0495 178.461C26.0683 177.332 25.1273 176.194 24.2328 175.068L24.109 174.916C24.1028 174.913 24.1028 174.903 24.0966 174.9C18.4447 167.757 14.5632 160.995 13.4303 158.247C10.6539 151.501 18.0887 154.882 19.9118 155.775C19.9551 155.797 19.9892 155.822 20.0356 155.84C18.5561 155.009 11.242 150.717 9.10933 145.794C7.12217 141.232 16.5937 142.938 19.8097 143.632C19.8561 143.642 19.9025 143.66 19.9489 143.663C20.1347 143.704 20.2925 143.741 20.4256 143.772C20.4813 143.787 20.5401 143.806 20.602 143.812C20.6423 143.828 20.6825 143.831 20.729 143.84C20.7537 143.849 20.7847 143.856 20.8125 143.859C20.2306 143.648 11.1244 140.372 7.38838 135.444L7.38218 135.441C6.45979 134.228 5.86241 132.913 5.80051 131.514C5.59003 126.669 16.6277 130.311 30.9124 131.387C33.5434 131.585 36.2857 131.697 39.0838 131.654L39.0869 131.648C43.866 131.573 48.8185 131.04 53.7059 129.706C53.7059 129.706 68.4331 121.995 78.4401 138.325C88.4564 154.653 90.62 186.845 65.8548 195.83Z",
    fill: "#282827"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0495 178.461L24.2328 175.068L24.109 174.916C24.1028 174.913 24.1028 174.903 24.0966 174.9C18.9306 165.918 27.6097 159.947 27.6097 159.947C19.757 151.532 28.5909 144.802 28.5909 144.802C23.6787 138.732 30.9124 131.393 30.9124 131.393L30.9155 131.387C33.5464 131.585 36.2888 131.697 39.0869 131.654C32.689 137.448 36.4219 145.878 36.4219 145.878C27.1887 153.691 34.0386 162.289 34.0386 162.289C25.3842 166.473 27.0495 178.461 27.0495 178.461Z",
    fill: "#D6D6D6"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5052 149.237C57.0085 148.883 20.8156 143.862 20.8156 143.862C20.2337 143.651 11.1274 140.376 7.39142 135.447C12.9165 139.69 72.005 149.594 64.5052 149.237Z",
    fill: "url(#paint32_linear_2_949)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6685 171.523C48.3015 168.954 20.147 155.896 20.147 155.896C20.1099 155.878 20.0696 155.859 20.0418 155.837C18.5622 155.006 11.2481 150.713 9.11548 145.791C11.9476 148.679 61.0385 174.084 54.6685 171.523Z",
    fill: "url(#paint33_linear_2_949)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1485 130.978C54.1485 130.978 65.3441 125.671 72.7324 132.851C80.1177 140.031 77.332 144.668 70.6122 143.325C63.8924 141.982 38.1553 133.67 54.1485 130.978Z",
    fill: "url(#paint34_linear_2_949)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_949",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(172.934 242.657) scale(29.0571 5.12505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7425,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_949",
    x1: 32.0929,
    y1: 246.051,
    x2: 79.2929,
    y2: 229.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_949",
    x1: 81.1771,
    y1: 210.273,
    x2: 80.7265,
    y2: 221.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_949",
    x1: 41.5092,
    y1: 240.855,
    x2: 99.361,
    y2: 220.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_949",
    x1: 98.9957,
    y1: 212.486,
    x2: 98.8956,
    y2: 223.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_949",
    x1: 16.1564,
    y1: 130.614,
    x2: 9.50085,
    y2: 131.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_949",
    x1: 26.5247,
    y1: 128.555,
    x2: 15.4019,
    y2: 130.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_949",
    x1: 136.538,
    y1: 11.8389,
    x2: 134.143,
    y2: 66.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2655,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7489,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9113,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_949",
    x1: 119.489,
    y1: 262.625,
    x2: 97.9356,
    y2: 203.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2655,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7489,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9113,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_949",
    x1: 143.888,
    y1: 103.08,
    x2: 134.373,
    y2: 136.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_949",
    x1: 156.827,
    y1: 30.1648,
    x2: 119.41,
    y2: 100.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2_949",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.661 93.0604) rotate(27.8404) scale(15.8603 17.9871)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#FEFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#FCFAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7858,
    stopColor: "#F7F2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#F1E8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#E9DBC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D5BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_949",
    x1: 194.14,
    y1: 62.8471,
    x2: 156.8,
    y2: 117.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2_949",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.249 111.634) rotate(26.2265) scale(10.3732 14.9692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#FEFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#FCFAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7858,
    stopColor: "#F7F2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#F1E8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#E9DBC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D5BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_949",
    x1: 26.5484,
    y1: 175.558,
    x2: 26.5552,
    y2: 175.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0E9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A499B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_949",
    x1: 135.999,
    y1: 116.461,
    x2: 143.047,
    y2: 126.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#631500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A62F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_949",
    x1: 146.4,
    y1: 110.544,
    x2: 142.131,
    y2: 125.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_949",
    x1: 152.017,
    y1: 110.217,
    x2: 144.701,
    y2: 114.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_949",
    x1: 146.748,
    y1: 127.13,
    x2: 142.024,
    y2: 128.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_949",
    x1: 138.127,
    y1: 124.175,
    x2: 138.19,
    y2: 129.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2_949",
    x1: 191.107,
    y1: 216.158,
    x2: 191.909,
    y2: 227.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2_949",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(191.815 226.251) rotate(-5.24534) scale(1.76559 2.55782)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#FEFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#FCFAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7858,
    stopColor: "#F7F2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#F1E8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#E9DBC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D5BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2_949",
    x1: 190.868,
    y1: 224.117,
    x2: 192.02,
    y2: 226.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2655,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7489,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9113,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2_949",
    x1: 171.026,
    y1: 222.27,
    x2: 171.026,
    y2: 239.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB7E7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2_949",
    x1: 171.36,
    y1: 224.909,
    x2: 171.209,
    y2: 229.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2655,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7489,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9113,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2_949",
    x1: 155.688,
    y1: 232.1,
    x2: 155.555,
    y2: 236.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2655,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7489,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9113,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2_949",
    x1: 190.486,
    y1: 215.878,
    x2: 188.344,
    y2: 221.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2655,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7489,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9113,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2_949",
    x1: 162.24,
    y1: 254.539,
    x2: 162.39,
    y2: 240.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2_949",
    x1: 184.506,
    y1: 262.81,
    x2: 184.749,
    y2: 239.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2_949",
    x1: 186.981,
    y1: 214.192,
    x2: 187.945,
    y2: 227.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2_949",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(187.834 226.315) rotate(-4.10111) scale(2.70836 3.07438)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#FEFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#FCFAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7858,
    stopColor: "#F7F2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#F1E8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#E9DBC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D5BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2_949",
    x1: 100.301,
    y1: 63.5334,
    x2: 23.6439,
    y2: 188.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2_949",
    x1: 26.6978,
    y1: 177.732,
    x2: 36.8013,
    y2: 140.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2_949",
    x1: 23.6216,
    y1: 175.986,
    x2: 32.651,
    y2: 157.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4691,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2_949",
    x1: 67.9013,
    y1: 97.8955,
    x2: 62.5832,
    y2: 140.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2655,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7489,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9113,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird3);
export default __webpack_public_path__ + "static/media/Bird3.699d518ae2fcd09257080bdcfc440210.svg";
export { ForwardRef as ReactComponent };